"use strict";

/*
 *  Messa la dipendenza dal servizio toastService definito nei core. In questo modo definisci le configurazioni dei toast lì dentro.
 *  D'altro canto non puoi utilizzare Notify se non hai un core.
 */

module.exports = ['ngDroHandlerLanguage', '$uibModal', 'toastService', 'ngDroUtilsDeregisterListner',
    function (ngDroHandlerLanguage, $uibModal, toastService, ngDroUtilsDeregisterListner) {

        /*
         * Configs
         */

        const htmlContent = require('./toast-templates/' + global.ngDroUtilsNotifyConfigs.toastTemplate.toString() + '.html').toString(); // scelgo il template

        const NotHandlingErrorCode = global.ngDroUtilsNotifyConfigs.notHandlingErrorCode || [];

        /*
         * Methods
         */

        this.success = function (itemTitle, message, headTitle) {
            headTitle = headTitle || 'utils_notify.success';
            message = message ? ngDroHandlerLanguage.getKeyValue(message) : "{0}";

            toastService.createSuccessToast(htmlContent.sformat(ngDroHandlerLanguage.getKeyValue(headTitle), message.sformat(itemTitle), 'check-circle'));
        };

        this.error = function (itemTitle, message, headTitle, reason) {
            if (reason && (-1 !== NotHandlingErrorCode.indexOf(reason.status))) {
                return;
            }
            headTitle = headTitle || 'utils_notify.error';
            message = message ? ngDroHandlerLanguage.getKeyValue(message) : "{0}";

            toastService.createErrorToast(htmlContent.sformat(ngDroHandlerLanguage.getKeyValue(headTitle), message.sformat(itemTitle), 'times-circle'));
        };

        this.warning = function (itemTitle, message, headTitle, reason) {
            reason = reason ? reason : '';
            headTitle = headTitle || 'utils_notify.warning';
            message = message ? ngDroHandlerLanguage.getKeyValue(message) : "{0}";

            toastService.createWarningToast(htmlContent.sformat(ngDroHandlerLanguage.getKeyValue(headTitle), message.sformat(itemTitle), 'exclamation-triangle'));
        };

        this.info = function (itemTitle, message, headTitle, reason) {
            reason = reason ? reason : '';
            headTitle = headTitle || 'utils_notify.info';
            message = message ? ngDroHandlerLanguage.getKeyValue(message) : "{0}";

            toastService.createInfoToast(htmlContent.sformat(ngDroHandlerLanguage.getKeyValue(headTitle), message.sformat(itemTitle), 'info-circle'));
        };

        this.insertSuccess = function (itemTitle) {
            return this.success(itemTitle, 'utils_notify.insert_success', 'utils_notify.insert_head');
        };

        this.insertError = function (itemTitle, reason) {
            return this.error(itemTitle, 'utils_notify.insert_error', 'utils_notify.error', reason);
        };

        this.updateSuccess = function (itemTitle) {
            return this.success(itemTitle, 'utils_notify.update_success', 'utils_notify.update_head');
        };

        this.updateError = function (itemTitle, reason) {
            return this.error(itemTitle, 'utils_notify.update_error', 'utils_notify.error', reason);
        };

        this.deleteSuccess = function (itemTitle) {
            return this.success(itemTitle, 'utils_notify.delete_success', 'utils_notify.delete_head');
        };

        this.deleteError = function (itemTitle, reason) {
            return this.error(itemTitle, 'utils_notify.delete_error', 'utils_notify.error', reason);
        };

        this.confirmAction = function (options) {

            var itemTitle = options.itemTitle || "";
            var headTitle = options.headTitle || "utils_notify.confirm_action_title";
            var detail = options.detail || "utils_notify.confirm_action.detail";
            var success_callback = options.success || {};
            var dismiss_callback = options.dismiss || {};
            var messageModalDelete = ngDroHandlerLanguage.getKeyValue('utils_notify.confirm_action').sformat(itemTitle);
            var titleModal = ngDroHandlerLanguage.getKeyValue(headTitle);
            var modalDetail = ngDroHandlerLanguage.getKeyValue(detail).sformat(itemTitle);

            return _notifyAction(modalDetail, messageModalDelete, titleModal, success_callback, dismiss_callback, options);
        };

        this.confirmDelete = function (options) {

            var itemTitle = options.itemTitle || "";
            var headTitle = options.headTitle || "utils_notify.confirm_delete_title";
            var detail = options.detail || "utils_notify.confirm_delete.detail";
            var callback = options.success || {};
            var messageModalDelete = ngDroHandlerLanguage.getKeyValue('utils_notify.confirm_delete').sformat(itemTitle);
            var titleModalDelete = ngDroHandlerLanguage.getKeyValue(headTitle);
            var modalDetail = ngDroHandlerLanguage.getKeyValue(detail).sformat(itemTitle);

            return _notifyDelete(modalDetail, messageModalDelete, titleModalDelete, callback);
        };

        this.confirmUnsavedChanges = function (options) {

            var itemTitle = options.itemTitle || "";
            var headTitle = options.headTitle || "utils_notify.edit";
            var detail = options.detail || "utils_notify.confirm_update.detail";
            var success_callback = options.success || {};
            var dismiss_callback = options.dismiss || {};
            var messageModalDelete = options.name ? ngDroHandlerLanguage.getKeyValue('utils_notify.confirm_update').sformat(options.name) : ngDroHandlerLanguage.getKeyValue('utils_notify.confirm_update.no_name');
            var titleModalDelete = ngDroHandlerLanguage.getKeyValue(headTitle);
            var modalDetail = ngDroHandlerLanguage.getKeyValue(detail);

            return _notifyUnsavedChanges(modalDetail, messageModalDelete, titleModalDelete, success_callback, dismiss_callback, options);
        };

        function _notifyAction(modalDetail, modalMessage, modalTitle,  success_callback, dismiss_callback, options){

            function confirmCtrl($scope) {
                $scope.object = {
                    message: modalMessage,
                    title: modalTitle,
                    detail: modalDetail
                };

                // Chiusura della finestra modale.
                $scope.cancel = function () {
                    dismiss_callback()
                    modalInstance.dismiss('canceled');
                };

                // Effettiva cancellazione dell'oggetto.                 
                $scope.delete = function () {
                    // Chiamata della funzione di cancellazione.
                    success_callback();
                    modalInstance.close();
                };
            }

            var modalInstance = $uibModal.open({
                template: require('./NotifyAction.html'),
                backdrop: true,
                windowClass: 'custom-modal',
                controller: ['$scope', confirmCtrl]
            });
        }

        function _notifyDelete(modalDetail, modalMessage, modalTitle, callback) {

            function deleteCtrl($scope) {
                $scope.object = {
                    message: modalMessage,
                    title: modalTitle,
                    detail: modalDetail
                };

                // Chiusura della finestra modale.
                $scope.cancel = function () {
                    modalInstance.dismiss('canceled');
                };

                // Effettiva cancellazione dell'oggetto.                 
                $scope.delete = function () {
                    // Chiamata della funzione di cancellazione.
                    callback();
                    modalInstance.close();
                };
            }

            var modalInstance = $uibModal.open({
                template: require('./NotifyDelete.html'),
                backdrop: true,
                windowClass: 'custom-modal',
                controller: ['$scope', deleteCtrl]
            });
        }

        function _notifyUnsavedChanges(modalDetail, modalMessage, modalTitle, success_callback, dismiss_callback, options) {

            function unsavedChangesCtrl($scope) {
                $scope.object = {
                    message: modalMessage,
                    title: modalTitle,
                    detail: modalDetail,
                    resource: options
                };

                $scope.hasPerms = options.perms;

                // Effettivo salvataggio dell'oggetto.   
                $scope.ok = function () {
                    success_callback(options.form.$valid, options.next);
                    modalInstance.close('approved');
                };

                // Chiusura della finestra modale.
                $scope.cancel = function () {
                    dismiss_callback(options.next);
                    modalInstance.dismiss('canceled');
                };
            }

            var modalInstance = $uibModal.open({
                template: require('./NotifyUnsavedChanges.html'),
                windowClass: 'custom-modal',
                size: 'md',
                backdrop: 'static', // catch dentro dismissed con message==="backdrop click"
                keyboard: false,
                controller: ['$scope', unsavedChangesCtrl]
            });
        }

        this.openModal = function (options) {
            return $uibModal.open(options);
        };

        /*
         * API
         */
        return {
            success: this.success,
            error: this.error,
            warning: this.warning,
            info: this.info,
            insertSuccess: this.insertSuccess,
            insertError: this.insertError,
            updateSuccess: this.updateSuccess,
            updateError: this.updateError,
            deleteSuccess: this.deleteSuccess,
            deleteError: this.deleteError,
            confirmDelete: this.confirmDelete,
            confirmAction: this.confirmAction,
            confirmUnsavedChanges: this.confirmUnsavedChanges,

            getDeregisterListner: ngDroUtilsDeregisterListner.getDeregisterListner,
            setDeregisterListner: ngDroUtilsDeregisterListner.setDeregisterListner,
            unregisterListner: ngDroUtilsDeregisterListner.unregisterListner
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/services/notify/Notify.js
// module id = 438
// module chunks = 0